module.exports = __webpack_public_path__ + "static/media/index-banner.f9e0aa3a.png";